import useGetTechnologyInitialValues from './useGetTechnologyInitialValues'

export default useGetTechnologyInitialValues
